// extracted by mini-css-extract-plugin
export default {"wrapper":"sz-z","button":"tz-z","alternate":"uz-z","disabled":"vz-z","paymentWarning":"wz-z","fadeIn":"xz-z"};